import React from 'react';

const Terms = () => {
  return (
    <div dir="ltr" className="min-h-screen bg-[#120F1D] text-gray-300 p-6 max-w-2xl mx-auto font-sans text-left">
      <h1 className="text-2xl font-bold text-white mb-4">Terms of Service</h1>
      <p className="text-sm leading-relaxed mb-4">
        Welcome to CandleDuel. By connecting your wallet and using our platform, you agree to the following terms and conditions:
      </p>
      <ul className="list-disc pl-5 text-sm space-y-2 text-gray-400">
        <li>You must be of legal age in your jurisdiction to use trading prediction features.</li>
        <li>Users are solely responsible for managing their connected wallets and private keys.</li>
        <li>CandleDuel provides a peer-to-peer trading prediction mechanism and is not responsible for market volatility.</li>
      </ul>
    </div>
  );
};

export default Terms;